import { useRollbar } from '@rollbar/react';
import { useCallback } from 'react';
import invariant from 'tiny-invariant';
function isLogArgument(arg) {
    return (['string', 'function', 'object'].includes(typeof arg) ||
        arg instanceof Error ||
        arg instanceof Date ||
        Array.isArray(arg));
}
export function useReportError() {
    const rollbar = useRollbar(); // eslint-disable-line @typescript-eslint/no-unsafe-call
    return useCallback((message, error) => {
        invariant(isLogArgument(error), 'Invalid log argument');
        if (process.env.NODE_ENV === 'production') {
            rollbar.error(message, error);
        }
        else {
            console.error({ message, error }); // eslint-disable-line no-console,@typescript-eslint/no-unsafe-assignment
        }
    }, [rollbar]);
}
